module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2rVYV"))).then(() => parcelRequire('ikE14'));